import { Bot } from 'lucide-react'
import { useTranslation } from 'react-i18next'

import { Spinner } from '@/components/ui'
import { ModuleEmptyPage } from '@/components/layout/ModuleEmptyPage'
import { PausedForCreditsAlert } from '@/features/billing/components/PausedForCredits'
import { useCurrentTenant } from '@/features/tenants/useCurrentTenant'

import { AgentsList } from './components/AgentsList'

/**
 * Tela de Agentes: o usuario ve seus agentes, o modo de cada um (sempre visivel), troca o modo com
 * seguranca (ligar "Resposta automatica" exige confirmacao) e testa o agente no Playground embutido.
 * Vocabulario neutro (docs/design/00 s5); nunca expoe infraestrutura nem termos crus de modo.
 */
export function AgentsPage() {
  const { t } = useTranslation()
  const { tenant, isLoading } = useCurrentTenant()

  if (isLoading) {
    return (
      <div className="flex justify-center py-12">
        <Spinner label={t('loading')} />
      </div>
    )
  }

  if (tenant === null) {
    return (
      <ModuleEmptyPage
        icon={Bot}
        title={t('modules.agents.title')}
        description={t('modules.agents.description')}
      />
    )
  }

  return (
    <div className="mx-auto flex w-full max-w-4xl flex-col gap-6">
      <header className="flex flex-col gap-1">
        <h1 className="text-xl font-semibold text-foreground-primary">{t('agents.pageTitle')}</h1>
        <p className="text-sm text-foreground-muted">{t('agents.pageSubtitle')}</p>
      </header>
      <PausedForCreditsAlert tenantId={tenant.id} tenantSlug={tenant.slug} />
      <AgentsList tenantId={tenant.id} />
    </div>
  )
}
